(() => {
  let loaded = false;
  const events = ['pointerdown', 'keydown', 'scroll', 'touchstart'];
  function loadResources() {
    if (loaded) return;
    loaded = true;
    events.forEach(event => window.removeEventListener(event, loadResources));
    document.querySelectorAll('iframe.lazy[data-src]').forEach(frame => {
      frame.src = frame.dataset.src;
      frame.removeAttribute('data-src');
    });
    Array.from(document.querySelectorAll('script[data-src], script[type="text/lazyload"]')).forEach(original => {
      if (original.type !== 'text/lazyload') {
        if (!original.hasAttribute('src')) original.src = original.dataset.src;
        original.removeAttribute('data-src');
        return;
      }
      const script = document.createElement('script');
      Array.from(original.attributes).forEach(attribute => {
        if (!['type', 'data-src', 'src'].includes(attribute.name)) script.setAttribute(attribute.name, attribute.value);
      });
      script.type = 'text/javascript';
      script.async = false;
      const source = original.dataset.src || original.getAttribute('src');
      if (source) script.src = source;
      else script.textContent = original.textContent;
      original.replaceWith(script);
    });
    document.querySelectorAll('link[data-href]').forEach(link => {
      link.href = link.dataset.href;
      link.removeAttribute('data-href');
    });
    document.dispatchEvent(new CustomEvent('asyncLazyLoad'));
  }
  events.forEach(event => window.addEventListener(event, loadResources, { once: true, passive: true }));
  window.setTimeout(loadResources, 5000);
})();
